// @flow
import * as React from "react"
import * as Util from "../common"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {CardText} from "material-ui/Card"
import {containers} from "@swarm2/core"
import {CombatRunContent} from "./CombatRun"

const M = Util.intlMessages("view.CombatResult")
const ZM = Util.intlMessages("zone")
const UM = Util.intlMessages("units")

function CombatLootItem(props) {
  const {unitName, count} = props
  return (
    <p>
      <M
        id="win.lootitem"
        values={{
          count,
          unitName: (
            <UM id={unitName + ".plural"} values={{count: count.toNumber()}} />
          ),
        }}
      />
    </p>
  )
}
function CombatLoot(props) {
  const {loot} = props
  return (
    <div>
      {Object.keys(loot).map(unitName => (
        <CombatLootItem
          key={unitName}
          unitName={unitName}
          count={loot[unitName]}
        />
      ))}
    </div>
  )
}
function CombatResultRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {
    charId,
    clientNow,
    exists,
    status,
    zone,
    loot,
    spend,
    isFirstZoneWin,
    hatcheryProdPerZone,
  } = props
  const RM = Util.intlMessages("view.CombatResult." + status)
  //console.log("combatresult", {error, exists})
  if (!exists) return <Util.NotFoundView />
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={<RM id="title" />} />
        </ToolbarGroup>
      </Toolbar>
      <CardText>
        <p>
          {isFirstZoneWin ? (
            <RM
              id="firststatus"
              values={{
                zone: <ZM id={zone} />,
                hatcheryProdPerZone: (
                  <Util.Percent val={hatcheryProdPerZone} minusone />
                ),
              }}
            />
          ) : (
            <RM id="status" values={{zone: <ZM id={zone} />}} />
          )}
        </p>
        {status === "win" && loot ? (
          <CombatLoot loot={loot} spend={spend} />
        ) : null}
      </CardText>
      <CombatRunContent charId={charId} clientNow={clientNow} />
    </div>
  )
}
export default containers.combat.CombatResult(
  Util.DumpProps(CombatResultRender),
)



// WEBPACK FOOTER //
// ./src/combat/CombatResult.js